import { render, staticRenderFns } from "./PoalPage.vue?vue&type=template&id=0364d288&scoped=true"
import script from "./PoalPage.vue?vue&type=script&lang=js"
export * from "./PoalPage.vue?vue&type=script&lang=js"
import style0 from "./PoalPage.vue?vue&type=style&index=0&id=0364d288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0364d288",
  null
  
)

export default component.exports